// src/services/authService.js
import customFetch from '../utils/fetch';
import { API_ENDPOINTS } from '../constants/api-endpoint';

export const login = async (email, password) => {
  return await customFetch(API_ENDPOINTS.LOGIN, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, password }),
  });
};

export const logout = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('userRole');
  localStorage.removeItem('userRoleName');
  sessionStorage.clear();
};

export default {
  login,
  logout,
};
